import { render } from "./Creative.vue?vue&type=template&id=75837e56&ts=true&lang=pug"
import script from "./Creative.vue?vue&type=script&lang=ts"
export * from "./Creative.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__